<template>
    <div class='sign-panel'>
        <div class='sign-warpper sign-fc'>
            <input v-model="fclink" class="sign-textbox" type="text" placeholder="仅支持翻唱歌曲链接，如http://5sing.kugou.com/fc/3312005.html" >
            <a class="sign-button" href="javascript:;" v-on:click="validFC">我要报名</a>
        </div>
    </div>
</template>
<script>
const fcRule =  /^http:\/\/5sing.kugou.com\/(fc)+\/\d+.html$/;
export default {
    name: "sign-fc",
    data() {
        return {
            signConfig: this.$winConfig.signConfig,
            columnIndex: 1,
            fclink: "",
            type: 'fc',
            dialogImageUrl: "",
            dialogVisible: false,
            isHttp: false
        };
    },
    mounted:function(){
        var _this = this;
        eventbus.$on("signMsg", function (res) {
            if(!_this.isHttp && res.type == 'signSuccess-'+_this.type){
                console.log("signMsg fc");
                _this.isHttp = true;
                _this.signFC();
            }
        });  
    },
    methods: {
        /**
         * 翻唱报名参赛。
         *
         * @param {string} id     加密栏目id。
         * @param {string} url    原创报名歌曲地址。
         * @param {number} isApp  是否使用app报名，其中1表示使用手机端进行报名；不传递该参数表示使用PC端进行报名。默认不传该参数。
         * @param {string} sign   如果使用了app进行报名（即isApp设置为1）时必须传递该参数，否则报名失败。
         * @param {number} type   报名类型，其中1表示歌曲报名；2表示歌单报名。默认歌曲报名。
         *
         */
        validFC:function(){
            // if((new Date()).getTime() > 1537113599000){
            //     this.$tipsBox.error({
            //         message: "很抱歉，报名已截止!"
            //     });
            //     return;
            // }
            if(!this.$winConfig.isLogin){
                this.$tipsBox.error({
                    message: "请先登录",
                    reload: "http://5sing.kugou.com/login/"
                });
            }else{
                if (this.fclink == "") {
                    this.$tipsBox.error({
                        message: "请填写歌曲地址！"
                    });
                } else if (fcRule.test(this.fclink)) {
                    this.$signMsg.show({type: this.type});
                }else{
                    this.$tipsBox.error({
                        message: "请使用翻唱歌曲报名参赛！"
                    });
                }
            }
        },
        signFC: function(event) {
            if(this.fclink != ""){
                 let formData = {
                    sid: this.signConfig[this.columnIndex].id,
                    signup_type: 2,
                    music_address: this.fclink
                };
                this.signHttp(formData);
            } 
        },
        /**
         * 报名请求。
         * @param {object} formData         请求参数
         * @param {string} ADD_WORK_URL     请求地址
         */
        signHttp: function(formData) {
            var _this = this;
            _this.$server.sign(formData,this.type).then(function(res){
                 res = res.data;
                if(0 === res.status){
                    _this.fclink = '';
                }
                _this.isHttp = false;
            }).catch(function(res){
                _this.isHttp = false;
            });
        }
    }
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "../assets/sass/cmn.scss";
// .sign-fc {
//     .sign-textbox {
//         border: 1px solid #dcc67e;
//     }
//     .sign-button {
//         background-image: url(componentsImgPath('index/sign-btnfc.png'));
//     }
// }

</style>


// WEBPACK FOOTER //
// src/components/sign-tab-fc.vue